import React from 'react';
import PropTypes from 'prop-types';
import './CollectionIcon.css';

/**
 * Generic collection/inventory icon component
 * @param {Object} props
 * @param {number} props.size - Icon size in pixels
 * @param {boolean} props.isActive - Whether the icon should be displayed in active state
 * @param {string} props.className - Additional CSS classes
 */
const CollectionIcon = ({ 
  size = 24,
  isActive = false,
  className = ''
}) => {
  return (
    <svg 
      width={size} 
      height={size} 
      version="1.1" 
      viewBox="0 0 1200 1200" 
      xmlns="http://www.w3.org/2000/svg"
      className={`collection-icon ${isActive ? 'collection-icon--active' : ''} ${className}`}
    >
      <path d="m1164 636-150-172.8c-3.6016-4.8008-8.3984-7.1992-13.199-8.3984-2.3984-1.1992-132-34.801-241.2-63.602l-42 42 175.2 46.801-292.8 76.801-292.8-76.801 175.2-45.602-42-42c-109.2 28.801-238.8 62.398-242.4 63.602-4.8008 1.1992-10.801 4.8008-13.199 8.3984-2.4023 1.2031-148.8 171.6-148.8 171.6-6 6-7.1992 15.602-4.8008 24 2.3984 8.3984 9.6016 15.602 18 16.801l129.6 34.801v286.8c0 12 8.3984 22.801 19.199 25.199l394.8 103.2c2.3984 0 4.8008 1.1992 6 1.1992 2.3984 0 4.8008 0 7.1992-1.1992l394.8-103.2c12-2.3984 19.199-13.199 19.199-25.199v-286.8l129.6-34.801c8.3984-2.3984 15.602-8.3984 18-16.801 3.5977-8.3984 1.1992-18-3.6016-24zm-1060.8 1.1992 111.6-129.6 338.4 88.801-111.6 129.6zm470.4 430.8-343.2-90-0.003906-253.2 213.6 56.398c2.3984 1.1992 4.8008 1.1992 7.1992 1.1992 7.1992 0 14.398-3.6016 19.199-9.6016l103.2-120zm396-90-343.2 90v-415.2l103.2 120c4.8008 6 12 9.6016 19.199 9.6016 2.3984 0 4.8008 0 7.1992-1.1992l213.6-55.199zm-211.2-250.8-111.6-129.6 8.3984-2.3984 330-86.398 111.6 129.6z"/>
      <path d="m582 441.6c4.8008 4.8008 12 7.1992 18 7.1992s13.199-2.3984 18-7.1992l99.602-99.602c9.6016-9.6016 9.6016-26.398 0-36-9.6016-9.6016-26.398-9.6016-36 0l-56.398 56.398-0.003906-264c0-14.398-10.801-26.398-25.199-26.398s-25.199 12-25.199 25.199v262.8l-56.398-56.398c-9.6016-9.6016-26.398-9.6016-36 0-9.6016 9.6016-9.6016 26.398 0 36z"/>
    </svg>
  );
};

CollectionIcon.propTypes = {
  size: PropTypes.number,
  isActive: PropTypes.bool,
  className: PropTypes.string
};

export default CollectionIcon;